import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Button } from 'primeng/button';
import { ConfirmDialog } from 'primeng/confirmdialog';

@Component({
  selector: 'app-global-confirm-dialog',
  imports: [Button, ConfirmDialog],
  templateUrl: './global-confirm-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalConfirmDialogComponent {}
